import { normalizeLoggedUsersFallback } from "./loggedUsersFallback";

export const SOCIAL_MEDIA_TONE_OPTIONS = [
  { value: "formal", labelKey: "agentsListPage.socialMediaToneFormal" },
  { value: "casual", labelKey: "agentsListPage.socialMediaToneCasual" },
  { value: "playful", labelKey: "agentsListPage.socialMediaTonePlayful" },
];

export const DEFAULT_SOCIAL_MEDIA_HANDOFF_RULE = {
  intent: "support",
  label: "Suporte",
  keywords: "reclamação, problema, defeito, cancelar",
  dest: "fila_humano",
  target_id: "",
  tipo_id: "",
  logged_users_only: false,
};

export function normalizeHandoffRules(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((rule, idx) => {
    const source = rule && typeof rule === "object" ? rule : {};
    const keywords = Array.isArray(source.keywords)
      ? source.keywords.join(", ")
      : String(source.keywords || "");
    const dest = String(source.dest || "fila_humano").trim();
    const loggedOnly =
      dest === "humano" &&
      (source.logged_users_only === true ||
        source.logged_users_only === 1 ||
        String(source.somenteusuarioslogados || "")
          .trim()
          .toLowerCase() === "sim");
    return {
      intent: String(source.intent || `rule_${idx + 1}`).trim(),
      label: String(source.label || source.intent || `Regra ${idx + 1}`).trim(),
      keywords,
      dest,
      target_id: source.target_id != null ? String(source.target_id) : "",
      tipo_id: source.tipo_id != null ? String(source.tipo_id) : "",
      logged_users_only: loggedOnly,
      logged_users_fallback: loggedOnly
        ? normalizeLoggedUsersFallback(source.logged_users_fallback)
        : null,
    };
  });
}

export function handoffRuleToTransfer(rule = {}) {
  return {
    dest: rule.dest || "fila_humano",
    target_id: rule.target_id || "",
    tipo_id: rule.tipo_id || "",
    logged_users_only: rule.logged_users_only === true,
    logged_users_fallback: rule.logged_users_only === true ? rule.logged_users_fallback || null : null,
  };
}

export function transferToHandoffRule(transfer = {}, prev = {}) {
  const dest = transfer.dest || prev.dest || "fila_humano";
  const hasFlag = Object.prototype.hasOwnProperty.call(transfer, "logged_users_only");
  const hasFallback = Object.prototype.hasOwnProperty.call(transfer, "logged_users_fallback");
  const loggedUsersOnly =
    dest === "humano" &&
    (hasFlag ? transfer.logged_users_only === true : prev.logged_users_only === true);
  return {
    ...prev,
    dest,
    target_id: transfer.target_id || "",
    tipo_id: transfer.tipo_id || "",
    logged_users_only: loggedUsersOnly,
    logged_users_fallback: loggedUsersOnly
      ? normalizeLoggedUsersFallback(
          hasFallback ? transfer.logged_users_fallback : prev.logged_users_fallback
        )
      : null,
  };
}
